import { render } from "./LoadSpinner.vue?vue&type=template&id=4b259148&scoped=true"
const script = {}

import "./LoadSpinner.vue?vue&type=style&index=0&id=4b259148&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b259148"]])

export default __exports__